import { Link } from "@tanstack/react-router";
import { SERVICE_CASES_BY_SLUG, serviceCaseCount, serviceCaseTopics } from "@/data/_cases/registry";

/**
 * Internal-link teaser from a service hub to its situational case-study hub.
 * Shows a handful of topic sub-hubs so the deep /cases/<service>/<topic>
 * pages have inbound links from the main cluster, not only from /cases.
 */
export function CasesTeaser({ service, limit = 8 }: { service: string; limit?: number }) {
  const cfg = SERVICE_CASES_BY_SLUG[service];
  if (!cfg) return null;
  const topics = serviceCaseTopics(service).slice(0, limit);
  return (
    <section className="mx-auto max-w-6xl px-4 py-8">
      <h2 className="mb-2 text-2xl font-bold">สถานการณ์ตัวอย่างงาน{cfg.th}: ควรเตรียมอะไรบ้าง</h2>
      <p className="mb-4 max-w-3xl text-sm text-muted-foreground">
        สถานการณ์จำลองแยกตามประเภทเอกสาร ประเทศปลายทาง พื้นที่ และกลุ่มผู้ใช้ ช่วยให้เห็นขั้นตอนที่มักต้องทำ จุดที่มักติดขัด
        และวิธีเตรียมรับมือก่อนเริ่มงาน ไม่ใช่ผลงานหรือคำรับรองของลูกค้ารายใด และไม่รับประกันผล
        เพราะผลขึ้นกับข้อเท็จจริงและดุลพินิจของหน่วยงานผู้รับเอกสาร
      </p>
      <ul className="grid gap-2 text-sm md:grid-cols-2 lg:grid-cols-4">
        {topics.map((t) => (
          <li key={t.slug}>
            <Link
              to="/cases/$service/$topic"
              params={{ service, topic: t.slug }}
              className="text-blue-700 hover:underline"
            >
              {t.th}
            </Link>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-sm">
        <Link to="/cases/$service" params={{ service }} className="font-medium text-blue-700 hover:underline">
          ดูสถานการณ์ตัวอย่าง{cfg.th}ทั้งหมด →
        </Link>
      </p>
    </section>
  );
}
